import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertLevel, MetricType } from "@madmedical/medical";
import { HStack, Text, VStack } from "native-base";
import { formatDate } from "@madmedical/utils";
import { useTranslation } from "@madmedical/i18n";
import PressableLink from "../../atoms/PressableLink";
import { thumbnailRoot, thumbnailUnit, thumbnailValue, thumbnailValueSlot, } from "../useStyles";
import RangeChart from "./RangeChart";
const SleepTimeWidget = ({ alertLevel, measuredAt, value, unit }) => {
    const getIndex = () => {
        switch (alertLevel) {
            case AlertLevel.Alert:
                return 0;
            case AlertLevel.Warning:
                return 1;
            case AlertLevel.Ok:
                return 2;
            default:
                return 0;
        }
    };
    const { t } = useTranslation();
    return (_jsx(VStack, Object.assign({ style: thumbnailRoot }, { children: _jsxs(PressableLink, Object.assign({ route: "measurements", params: { metricType: MetricType.SleepTime }, flex: 1 }, { children: [_jsx(Text, Object.assign({ fontSize: "sm", fontWeight: "medium", color: "black" }, { children: t("measures:sleep")[0].toUpperCase() +
                        t("measures:sleep").slice(1) })), _jsxs(HStack, Object.assign({ style: thumbnailValueSlot, space: 1 }, { children: [_jsx(Text, Object.assign({ numberOfLines: 1, style: thumbnailValue }, { children: value[0] })), _jsx(Text, Object.assign({ style: thumbnailUnit }, { children: unit[0] })), _jsx(Text, Object.assign({ numberOfLines: 1, style: thumbnailValue }, { children: value[1] })), _jsx(Text, Object.assign({ style: thumbnailUnit }, { children: unit[1] }))] })), _jsx(VStack, Object.assign({ flex: 1, justifyContent: "flex-end", mb: 2, minH: "10" }, { children: !!alertLevel && (_jsx(RangeChart, { length: 3, selectedIndex: getIndex(), alertLevel: alertLevel })) })), _jsx(Text, Object.assign({ fontSize: "xs", color: "gray.600", textAlign: "right", textTransform: "capitalize" }, { children: formatDate(measuredAt) }))] })) })));
};
export default SleepTimeWidget;
